<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo"
                   :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'lzyg'" v-model="formData.lzyg" :required="isRequired('lzyg')" name="flowName"
                   label="离职员工" placeholder="离职员工" input-align="right" :rules="getRules('lzyg')">
          <template #input>
            <view-item @click.native="isShowPopup(deptUserTreeAll,'lzyg')" :treeData="deptUserTreeAll.data"
                       :value="formData.lzyg" placeholder="请选择离职员工"/>
            <van-popup position="bottom" v-model="deptUserTreeAll.show">
              <van-nav-bar title="选择离职员工" left-text="取消" right-text="确定"
                           @click-left="deptUserTreeAll.show = false" @click-right="handlePopupSubmit"/>
              <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.tree)" clearable
                          shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree ref="tree" @check-change="singleChoice($event,$refs.tree)" node-key="uuid" check-strictly
                           :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node
                           show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-notice-bar scrollable
                        text="为避免影响系统正常使用，请在填写离职日期时务必谨慎。您可在流程的最终步骤再次确认具体的离职时间。一旦流程完成，系统将在您设定的离职日期自动更新您的离职状态。"/>
        <van-field v-f-show="'lzrq'" v-model="formData.lzrq" :required="isRequired('lzrq')" name="lzrq" label="离职日期"
                   placeholder="离职日期" input-align="right" :rules="getRules('lzrq')">
          <template #input>
            <view-item @click.native="isShowPopup(lzrq,'lzrq')" :value="formData.lzrq" placeholder="请选择离职日期"/>
            <van-calendar :min-date="minDate" v-model="lzrq.show" ref="lzrq" :show-confirm="false" title="选择离职日期"
                          @confirm="lzrqConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'sy'" input-align="right" name="sy" :required="isRequired('sy')" :rules="getRules('sy')"
                   :value="formData.sy" label="离职原因" placeholder="请选择离职原因">
          <template #input>
            <view-item @click.native="isShowPopup(sy,'sy')" :value="formData.sy" placeholder="请选择离职原因"/>
            <van-popup v-model="sy.show" position="bottom">
              <van-nav-bar title="选择离职原因" left-text="取消" right-text="确定" @click-left="sy.show = false"
                           @click-right="popupSubmit('sy')"/>
              <van-search v-model="sy.filterText" @input="pickerSearch($event,sy)" clearable shape="round"/>
              <van-picker ref="sy" :columns="sy.filteredData" @cancel="sy.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'bz'" v-model="formData.bz" :disabled="isDisabled('bz')" :required="isRequired('bz')"
                   :rules="getRules('bz')" name="bz" type="textarea" maxlength="200" rows="3" autosize label="备注"
                   show-word-limit placeholder="请输入备注" input-align="right"/>
        <van-field v-f-show="'czsqfj'"  class="fileValueBox"  :value.prop="formData.czsqfj" input-align="right" name="czsqfj"
                   :required="isRequired('czsqfj')" :rules="getRules('czsqfj')" label="辞职申请（签字）"
                   placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('czsqfj')" :files="formData.czsqfj"
                         @success="(fileList) => {uploadSuccess(fileList,'czsqfj')}" module-type="flow"
              @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','czsqfj')"            
                         ></uploadFiles>
          </template>
        </van-field>

        <van-field v-f-show="'jjbfj'"  class="fileValueBox"  :value.prop="formData.jjbfj" input-align="right" name="jjbfj"
                   :required="isRequired('jjbfj')" :rules="getRules('jjbfj')" label="交接表（双方签字）"
                   placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('jjbfj')" :files="formData.jjbfj"
               @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','jjbfj')" 
                         @success="(fileList) => {uploadSuccess(fileList,'jjbfj')}" module-type="flow"></uploadFiles>
          </template>
        </van-field>

        <van-field v-f-show="'qtfj'"  class="fileValueBox"  :value.prop="formData.qtfj" input-align="right" name="qtfj"
                   :required="isRequired('qtfj')" :rules="getRules('qtfj')" label="其他附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('qtfj')" :files="formData.qtfj"
               @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','qtfj')" 
                         @success="(fileList) => {uploadSuccess(fileList,'qtfj')}" module-type="flow"></uploadFiles>
          </template>
        </van-field>

      </van-cell-group>
      <div class="font-32 font-weight-500 cor-00 m-t-26">交接内容</div>
      <van-cell-group v-for="(item,index) in formData.jjnr" :key="index" class="m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center">
            <van-col :span="22">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`"></img>
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `明细${index + 1}` }}</span>
            </van-col>
            <van-col v-if="isShowIcon('jjnr')" @click="removeItem(index,'jjnr')" :span="2">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </van-col>
          </van-row>
        </div>
        <van-field v-f-show="'nr'" v-model="item.nr" :disabled="isDisabled('nr')" :required="isRequired('nr')"
                   :rules="getRules('nr')" name="nr" type="textarea" maxlength="200" rows="3" autosize label="内容"
                   show-word-limit placeholder="请输入内容" input-align="right"/>
        <van-field v-f-show="'jjxs'" input-align="right" name="jjxs" :required="isRequired('jjxs')"
                   :rules="getRules('jjxs')" :value="formData.jjxs" label="交接形式" placeholder="请选择交接形式">
          <template #input>
             <!-- <view-item v-if="isDisabled('jjxs')" :value="item.jjxs.join(',')"/> -->
            <div v-if="isDisabled('jjxs')">{{ item.jjxs.join(',') }}</div>
            <van-checkbox-group v-else v-model="item.jjxs" checked-color="#FFDA3E" direction="horizontal">
              <van-checkbox shape="square" name="电子">电子</van-checkbox>
              <van-checkbox shape="square" name="书面">书面</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field v-f-show="'jjry'" v-model="item.jjry" name="jjry" :required="isRequired('jjry')"
                   :rules="getRules('jjry')" label="接收人" placeholder="接收人" input-align="right">
          <template #input>
            <view-item @click.native="popupShow(jjry.show,index,'jjry')" :treeData="deptUserTreeAll.data"
                       :value="item.jjry" placeholder="请选择接收人"/>
            <van-popup position="bottom" v-model="jjry.show[index]">
              <van-nav-bar title="选择接收人" left-text="取消" right-text="确定"
                           @click-left="popupHidden(jjry.show,index)" @click-right="jjryPopupSubmit(item,index)"/>
              <van-search v-model="jjry.filterText[index]" @input="treeSearch($event,$refs[`jjryTree_${index}`])"
                          clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-35">
                <div class="p-10">
                  <el-tree :ref="`jjryTree_${index}`"
                           @check-change="singleChoice($event,$refs[`jjryTree_${index}`],index)" node-key="uuid"
                           check-strictly :data="jjry.data" :filter-node-method="filterNode" check-on-click-node
                           show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'sm'" v-model="item.sm" :disabled="isDisabled('sm')" :required="isRequired('sm')"
                   :rules="getRules('sm')" name="sm" type="textarea" maxlength="200" rows="3" autosize label="说明"
                   show-word-limit placeholder="请输入说明" input-align="right"/>
        <van-field v-f-show="'sfjj'" input-align="right" name="sfjj" :required="isRequired('sfjj')"
                   :rules="getRules('sfjj')" :value="formData.sfjj" label="是否交接" placeholder="请选择是否交接">
          <template #input>
            <view-item v-if="isDisabled('sfjj')" :value="item.sfjj"/>

            <van-radio-group v-else v-model="item.sfjj" checked-color="#FFDA3E" direction="horizontal">
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>
      <van-row v-if="!isDisabled('zffsmxb')">
        <van-col :span="12"></van-col>
        <van-col :span="12">
          <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加交接内容" @click="addItem"
                      class="width-100"/>
        </van-col>
      </van-row>
      <template >
        <div v-f-show="'qjqk'"  class="font-32 font-weight-500 cor-00 m-t-26">考勤情况</div>
        <van-cell-group v-f-show="'qjqk'" class="m-t-20">
          <van-field v-f-show="'qjqk'" v-model="formData.qjqk" :disabled="isDisabled('qjqk')"
                     :required="isRequired('qjqk')" :rules="getRules('qjqk')" name="qjqk" type="textarea"
                     maxlength="200"
                     rows="3" autosize label="请假情况" show-word-limit placeholder="请输入请假情况"
                     input-align="right"/>
          <van-row v-if="!isDisabled('qjqk')">
            <van-col :span="12"></van-col>
            <van-col :span="12">
              <van-button native-type="button" color="#FFDA3E" text="获取请假记录" @click="getLeaveInfo"
                          class="width-100"/>
            </van-col>
          </van-row>
        </van-cell-group>

        <van-cell-group  v-f-show="'dkqk'" class="m-t-20">
          <van-field v-f-show="'dkqk'" v-model="formData.dkqk" :disabled="isDisabled('dkqk')"
                     :required="isRequired('dkqk')" :rules="getRules('dkqk')" name="dkqk" type="textarea"
                     maxlength="200"
                     rows="3" autosize label="打卡情况" show-word-limit placeholder="请输入打卡情况"
                     input-align="right"/>
          <van-row v-if="!isDisabled('dkqk')">
            <van-col :span="12"></van-col>
            <van-col :span="12">
              <van-button native-type="button" color="#FFDA3E" text="获取打卡记录" @click="getCheckInInfo"
                          class="width-100"/>
            </van-col>
          </van-row>
        </van-cell-group>
      </template>


      <div v-f-show="'gzjzrq'" class="font-32 font-weight-500 cor-00 m-t-26">五险一金及薪资结算</div>
      <van-cell-group class="m-t-20">
        <van-field v-f-show="'gzjzrq'" v-model="formData.gzjzrq" :required="isRequired('gzjzrq')" name="gzjzrq"
                   label="工资截止日期" placeholder="工资截止日期" input-align="right" :rules="getRules('gzjzrq')">
          <template #input>
            <view-item @click.native="isShowPopup(gzjzrq,'gzjzrq')" :value="formData.gzjzrq"
                       placeholder="请选择工资截止日期"/>
            <van-calendar :min-date="minDate" v-model="gzjzrq.show" ref="gzjzrq" :show-confirm="false"
                          title="选择工资截止日期"
                          @confirm="gzjzrqConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'sbzhjnyf'" :value="formData.sbzhjnyf[1]" :required="isRequired('sbzhjnyf')"
                   name="sbzhjnyf"
                   label="社保截止月份" placeholder="社保截止月份" input-align="right" :rules="getRules('sbzhjnyf')">
          <template #input>
            <view-item @click.native="isShowPopup(sbzhjnyf,'sbzhjnyf')" :value="formData.sbzhjnyf"
                       placeholder="社保截止月份"/>
            <van-popup v-model="sbzhjnyf.show" position="bottom">
              <van-nav-bar title="选择社保截止月份" left-text="取消" right-text="确定"
                           @click-left="sbzhjnyf.show = false"
                           @click-right="sbzhjnyfChange('sbzhjnyf')"/>
              <van-datetime-picker :show-toolbar="false" ref="sbzhjnyf" v-model="sbzhjnyf.currentDate" type="year-month"
                                   title="选择月份" :min-date="sbzhjnyf.minDate" :max-date="sbzhjnyf.maxDate"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-f-show="'gjjzhjnyf'" :value="formData.gjjzhjnyf[1]" :required="isRequired('gjjzhjnyf')"
                   name="gjjzhjnyf" label="公积金截止月份" placeholder="公积金截止月份" input-align="right"
                   :rules="getRules('gjjzhjnyf')">
          <template #input>
            <view-item @click.native="isShowPopup(gjjzhjnyf,'gjjzhjnyf')" :value="formData.gjjzhjnyf"
                       placeholder="公积金截止月份"/>
            <van-popup v-model="gjjzhjnyf.show" position="bottom">
              <van-nav-bar title="选择公积金截止月份" left-text="取消" right-text="确定"
                           @click-left="gjjzhjnyf.show = false" @click-right="gjjzhjnyfChange('gjjzhjnyf')"/>
              <van-datetime-picker :show-toolbar="false" ref="gjjzhjnyf" v-model="gjjzhjnyf.currentDate"
                                   type="year-month"
                                   title="选择月份" :min-date="gjjzhjnyf.minDate" :max-date="gjjzhjnyf.maxDate"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'qtsm'" v-model="formData.qtsm" :disabled="isDisabled('qtsm')"
                   :required="isRequired('qtsm')"
                   :rules="getRules('qtsm')" name="qtsm" type="textarea" maxlength="200" rows="3" autosize
                   label="其他说明" show-word-limit placeholder="请输入其他说明" input-align="right"/>
      </van-cell-group>

      <div v-f-show="'sfyqk'" class="font-32 font-weight-500 cor-00 m-t-26">财务确认</div>
      <van-cell-group class="m-t-20">
        <van-field v-f-show="'sfyqk'" input-align="right" name="sfyqk" :required="isRequired('sfyqk')"
                   :rules="getRules('sfyqk')" :value="formData.sfyqk" label="是否有欠款" placeholder="请选择是否有欠款">
          <template #input>
            <view-item v-if="isDisabled('sfyqk')" :value="formData.sfyqk"/>
            <van-radio-group v-else v-model="formData.sfyqk" checked-color="#FFDA3E" direction="horizontal">
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-f-show="'bxsfjq'" input-align="right" name="bxsfjq" :required="isRequired('bxsfjq')"
                   :rules="getRules('bxsfjq')" :value="formData.bxsfjq" label="报销是否结清"
                   placeholder="请选择报销是否结清">
          <template #input>
            <view-item v-if="isDisabled('bxsfjq')" :value="formData.bxsfjq"/>

            <van-radio-group v-else v-model="formData.bxsfjq" checked-color="#FFDA3E" direction="horizontal">
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>


      <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
      <!--      这个是不带选人的流程图    -->
      <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
                 :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
      <!--      这个是带选人的流程图    -->
      <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData"
                :formData="formData"/>
      <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
      <van-popup position="bottom" v-model="approver.show">
        <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                     @click-right="approverPopupSubmit"/>
        <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                    shape="round"/>
        <div style="overflow-y: auto" class="h-vh-50">
          <div class="p-10">
            <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                     check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                     show-checkbox/>
          </div>
        </div>
      </van-popup>
    </van-form>
  </div>
</template>

<script>
import {getCurrentUserDept, getDeptUserTreeAll} from '@/api/user.js'
import {getFormDataByInstanceId} from "@/api/flow";
import {getCheckInInfo, getLeaveInfo, leave_reason} from '@/api/departed'
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import relativeFlow from '@/components/flow/relativeFlow.vue'


const item = {
  nr: "",
  sfjj: "",
  jjry: null,
  jjxs: [],
  sm: ''
}
export default {
  mixins: [mixin,fileMixins],
  components: {approver, bottomBar, flowTrace, uploadFiles},
  data() {
    return {
      minDate: new Date(2024, 0, 1),
      formData: {
        sqr: '',
        lzyg: '',
        flowNo: '',
        ssbm: '',
        lzrq: '',
        sy: '',
        bz: '',
        qjqk: '',
        dkqk: '',
        czsqfj: [],
        jjbfj: [],
        qtfj: [],
        // 工资截止日期
        gzjzrq: '',
        // 社保截止月份
        sbzhjnyf: '',
        // 公积金截止月份
        gjjzhjnyf: '',
        // 是否有欠款
        sfyqk: '',
        // 报销是否结清
        bxsfjq: '',
        // 其他说明
        qtsm: '',
        jjnr: [{
          nr: "技术资料或市场客户资料（系统权限交接）",
          sfjj: "",
          jjry: null,
          jjxs: [],
          sm: ''
        }, {
          nr: "使用技术软件程序",
          sfjj: "",
          jjry: null,
          jjxs: [],
          sm: ''
        }, {
          nr: "公司设备和办公用具",
          sfjj: "",
          jjry: null,
          jjxs: [],
          sm: ''
        }]
      },
      // 离职日期
      lzrq: {
        show: false
      },
      sbzhjnyf: {
        show: false,
        minDate: moment().subtract(2, 'years').toDate(),
        maxDate: moment().add(2, 'years').toDate(),
        currentDate: moment().toDate(),
      },
      gjjzhjnyf: {
        show: false,
        minDate: moment().subtract(2, 'years').toDate(),
        maxDate: moment().add(2, 'years').toDate(),
        currentDate: moment().toDate(),
      },
      sy: {
        data: [],
        show: false,
        filteredData: [],
        filterText: ''
      },
      gzjzrq: {
        show: false
      },
      // 接收人
      jjry: {
        data: [],
        // 有多个popup时，需要一个数组来保存
        show: [],
        filterText: [],
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      account: {
        show: false,
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      rules: {}
    }
  },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.currentUserInfo = currentUserInfo;
      this.getCurrentUserDept(currentUserInfo)
    }
  },
  methods: {
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 离职事由
      this.get_leave_reason()
    },

    sbzhjnyfChange() {
      this.formData.sbzhjnyf = moment(this.$refs.sbzhjnyf.value).format('YYYY-MM')
      this.sbzhjnyf.show = false
    },
    gjjzhjnyfChange() {
      this.formData.gjjzhjnyf = moment(this.$refs.gjjzhjnyf.value).format('YYYY-MM')
      this.gjjzhjnyf.show = false
    },

    // 附件
    uploadSuccess(fileList, fields) {
      this.formData[fields] = fileList
    },
    // 获取请假情况
    getLeaveInfo() {
      getLeaveInfo().then(res => {
        this.formData.qjqk = res.msg
      })
    },
    // 获取打卡情况
    getCheckInInfo() {
      getCheckInInfo().then(res => {
        this.formData.dkqk = res.msg
      })
    },
    addItem() {
      this.formData.jjnr.push(JSON.parse(JSON.stringify(item)));
    },
    get_leave_reason() {
      leave_reason().then(res => {
        const list = res.data.map(item => {
          return item.dictLabel || ''
        })
        this.sy.filteredData = list
        this.sy.data = list
      })
    },
    removeItem(index, field) {
      if (this.formData[field].length === 1 && field !== 'relativeFlow') return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
      })
    },
    gzjzrqConfirm(date) {
      this.formData.gzjzrq = moment(date).format('YYYY-MM-DD')
      this.gzjzrq.show = false
    },
    lzrqConfirm(date) {
      this.formData.lzrq = moment(date).format('YYYY-MM-DD')
      this.lzrq.show = false
    },

    // 报销人弹窗
    handlePopupSubmit() {
      if (this.$refs.tree.getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一人', position: 'bottom'})
        return
      }
      this.formData.lzyg = this.$refs.tree.getCheckedNodes()[0].id
      // 切换人部门列表跟着换
      this.getCurrentUserDept(this.$refs.tree.getCheckedNodes()[0])
      this.deptUserTreeAll.show = false
    },
    jjryPopupSubmit(item, index) {
      if (this.$refs[`jjryTree_${index}`][0].getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一项', position: 'bottom'})
        return
      }
      item.jjry = this.$refs[`jjryTree_${index}`][0]?.getCheckedNodes()[0]?.id
      this.popupHidden(this.jjry.show, index)
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          resolve(res.data)
        })
      })
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
          this.$set(this.jjry, 'data', data)
        })
      })
    },
  }
}
</script>
